export const baseURL = "https://casino.famychat.com/";
export const adminBaseURL = "https://admin.famychat.com/";
export const key = "heb4l#2(sh+dy548d%8+4!airq#9q";